import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { ColumnApi, ColumnGroup, GridApi } from 'ag-grid-community';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-targetandachievement',
    template: require('./targetandachievement.component.html'),
    styles: []
})

export class TargetAndAchievementComponent implements OnInit {
    showMyContainer: boolean = false;
    private columnDefs;
    private rowData;
    private rowHeight;
    api: GridApi;
    columnApi: ColumnApi;
    private gridColumnApi;
    static parameters = [ApiService];
    empData: any;
    stateData: any;
    busy: Subscription;
    headQuarterList: any;
    date = new Date();
    token:any;
    year = this.date.getFullYear();
    month = (this.date.getMonth() + 1).toString().padStart(2, "0");
    defDate = this.year + '-' + this.month + '-' + this.date.getDate().toString().padStart(2, "0");
    target_Form = new FormGroup({
        fromDate: new FormControl(this.defDate, [Validators.required]),
        toDate: new FormControl(this.defDate, [Validators.required]),
        state: new FormControl(0, [Validators.required]),
        hq: new FormControl(0, [Validators.required]),
        employee: new FormControl(0, [Validators.required]),
    });
    targetData: any;


    constructor(private apiService: ApiService) {
        this.columnDefs = [
            { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 90 },
            { headerName: 'Date', field: 'Date', width: 250 },
            { headerName: 'Edmployee Name', field: 'empName', width: 250 },
            { headerName: 'Manager', field: 'Manager', width: 250 },
            { headerName: 'Target Retailer Call', field: 'targetRetailerCall', width: 250 },
            { headerName: 'Acheivement Retailer Call', field: 'acheivedRetailerCall', width: 250 },
            { headerName: 'Productive  Call', field: 'productiveCall', width: 250 },
            { headerName: 'Non Productive Call', field: 'nonProductiveCall', width: 250 },
            { headerName: 'Missed Call', field: 'missedCall', width: 250 },
            { headerName: 'Acheivment %', field: 'acheived_per', width: 250 },
            { headerName: 'Route', field: 'route', width: 300 },
            { headerName: 'Target', field: 'Target', width: 300 },
            //{ headerName: 'New Target', field: 'newTarget', width: 250 },
            { headerName: 'POB', field: 'pob', width: 250 },
            { headerName: 'Target Acheivment %', field: 'Targetacheived_per', width: 250 }
        ];


        this.rowHeight = 50;
    }

    addTourGridEventHandler() {
        this.showMyContainer = true;
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;

    }
    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'Target_vs_Acheivment' });
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        $('#filter-option').trigger('click');
        this.targetData = [];
        this.getEmployee();
        this.getState();
        this.getHeadQuarterList();
    }
    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empData = res.data;
            console.log("employee", this.empData)
        })
    }

    getState() {
        this.apiService.getState().subscribe((res: any) => {
            this.stateData = res.data;
        })
    }
    getHeadQuarterList() {
        this.apiService.getHeadQuarterList().subscribe((res: any) => {
            this.headQuarterList = res.data;
        })
    }
    gettargetach() {
        //this.api.showLoadingOverlay();
        let targetModel = this.target_Form.value;
        targetModel.LoginId=this.token.id;
        console.log(targetModel);
        this.busy = this.apiService.getTargetAcheivment(targetModel).subscribe((res: any) => {
            this.targetData = res.data;
        })
    }


}
